/**
 * Note: some of the assets here expire (e.g. Proximus assets, HT assets) so
 * they have to be regenerated or at least the auth tokens have to be updated
 * ... more info in the Epic DE-6876 and in linked tickets.
 */

const config_vod_1 = {
  source: {
    url: 'https://demo.castlabs.com:4443/vod/mp4:sample.mp4/hls.m3u8',
  },
  autoplay: true,
};

const config_vod_2 = {
  source: {
    url: 'https://demo.cf.castlabs.com/public/Client/tmp/marathon-hls/playlist.m3u8',
  },
  autoplay: true,
};

const config_vod_3 = {
  source: {
    url: 'https://castlabs-dl.s3.amazonaws.com/public/Transcodes/Testcontent/120min/STREAMING/HLS_clear_segmented/master.m3u8',
  },
  autoplay: true,
};

const config_vod_4 = {
  source: {
    url: 'https://livedash.castlabs.com/vod/testpic_2s/Manifest.mpd',
  },
  autoplay: true,
};

const config_live_1 = {
  source: {
    url: 'https://livedash.castlabs.com/livesim/testpic_2s/Manifest.mpd',
    type: 'application/dash+xml'
  },
  autoplay: true,
  metadata: {
    title: 'Live 1',
    index: 0,
  }
};

const config_bad = {
  source: {
    url: 'https://livedash.castlabs.com/livesim/testpic_2s/Manxxxxifest.mpd',
    type: 'application/dash+xml'
  },
  autoplay: true,
  metadata: {
    title: 'Bad source',
    index: 0,
  }
};

// Simple manifest
const config_live_2 = {
  source: {
    url: 'https://bpcdnmanprod.nexttv.ht.hr/bpk-tv/HRT1/default/index.mpd',
    type: 'application/dash+xml'
  },
  autoplay: true,
  metadata: {
    title: 'Live 2 - Jumbo manifest',
    index: 1,
  },
  streaming: {
    rebufferingGoal: 1,
    bufferingGoal: 1,
    startAtSegmentBoundary: true,
    ignoreDrift: true
  },
};

// Very complex manifest
const config_live_3 = {
  source: {
    url: 'https://livedash.castlabs.com/livesim/petv/Manifest.mpd',
    type: 'application/dash+xml'
  },
  autoplay: true,
  metadata: {
    title: 'Live 3',
    index: 2,
  },
  streaming: {
    rebufferingGoal: 1,
    bufferingGoal: 1,
    startAtSegmentBoundary: true,
    ignoreDrift: true
  },
};

const config_live_4 = {
  source: {
    url: 'https://usp-demo.castlabs.com/live/channel1/channel1.isml/hls.m3u8',
    type: 'application/x-mpegurl',
    drmProtected: true
  },
  metadata: {
    title: 'Live 4 WV',
    index: 3,
  },
  autoplay: true,
  drm: {
    env: 'DRMtoday_STAGING',
    customData: {
      userId: '',
      sessionId: '',
      merchant: 'six',
      fairPlayContentIdStrategy: 'full-skd',
      headers: {},
      deviceId: '',
      httpHeaderNames: {
        DeviceId: 'DeviceId',
        Authenticator: 'Authenticator'
      },
      assetId: 'channel3'
    },
    emeApi: ''
  },
};

// Direct HLS Playlist (1) live
const config_live_4b = {
  source: {
    url: 'https://usp-demo.castlabs.com/live/channel1/channel1.isml/channel1-video=800000.m3u8',
    type: 'application/x-mpegurl',
    drmProtected: true
  },
  metadata: {
    title: 'Live 4B WV',
    index: 3,
  },
  autoplay: true,
  drm: {
    env: 'DRMtoday_STAGING',
    customData: {
      userId: '',
      sessionId: '',
      merchant: 'six',
      fairPlayContentIdStrategy: 'full-skd',
      headers: {},
      deviceId: '',
      httpHeaderNames: {
        DeviceId: 'DeviceId',
        Authenticator: 'Authenticator'
      },
      assetId: 'channel3'
    },
    emeApi: ''
  },
};

const config_live_5 = {
  source: {
    url: 'https://usp-demo.castlabs.com/live/channel1/channel1.isml/channel1.mpd',
    type: 'application/dash+xml',
    drmProtected: true
  },
  metadata: {
    title: 'Live 4',
    index: 4,
  },
  autoplay: true,
  drm: {
    env: 'DRMtoday_STAGING',
    customData: {
      userId: '',
      sessionId: '',
      merchant: 'six',
      fairPlayContentIdStrategy: 'full-skd',
      headers: {},
      deviceId: '',
      httpHeaderNames: {
        DeviceId: 'DeviceId',
        Authenticator: 'Authenticator'
      },
      assetId: 'channel3'
    },
    emeApi: ''
  },
};

/**
 * The source.url expires after a few minutes so you have to regenerate
 * it before use.
 */
const live_proximus_1 = {
  source: {
    url: 'https://liveott.vcdn1.streaming.proximustv.be/sdash/LIVE$UAB248088/index.mpd,pxtoken=cGF0aFVSST0lMkZzZGFzaCUyRkxJVkUlMjRVQUIyNDgwODglMkYlMkEmZXhwaXJ5PTE3MDc5ODU2NDImZm49c2hhMjU2JnB1Ymxpc2hlcjEyMTImYy1pcC11bmxvY2tlZD0xOTUuMjM4LjI1LjM3LGJiZDA2NmJjYTc5MzA4YmQ4NTMwODZjZjNmYTUwYWY1ZTg4MWIzMmQ3NTE2MGEwNWUzNTZmMTc0Yzc5Yzg3YjM=/Manifest?device=DTVUH&start=LIVE&end=END',
    type: 'application/dash+xml',
    drmProtected: true
  },
  autoplay: true,
  drm: {
    env: 'HeaderDrm',
    customData: {
      userId: '',
      sessionId: '',
      merchant: '',
      widevineLicenseUrl: 'https://player.uat.proximusmwc.be/drm/staging/widevine',
      fairPlayContentIdStrategy: 'full-skd',
      headers: {
        deviceId: 'AW_MVP_PLAYER_TESTING_FRAMEWORK_UAT'
      },
      deviceId: '',
      httpHeaderNames: {
        DeviceId: 'DeviceId',
        Authenticator: 'Authenticator'
      }
    },
    emeApi: ''
  },
  metadata: {
    title: 'test'
  },
  textStyle: {
    fontFamily: "'Roboto', sans-serif",
    fontColor: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  }
};

const live_ht_dash_1 = {
  source: {
    url: 'https://bpcdnmanprod.nexttv.ht.hr/bpk-tv/RTL2/default/index.mpd',
    type: 'application/dash+xml',
  },
  metadata: {
    title: 'HT 1',
    index: 1,
  },
  autoplay: true,
  streaming: {
    rebufferingGoal: 1,
    bufferingGoal: 1,
    startAtSegmentBoundary: true,
    ignoreDrift: true
  },
};

const live_ht_dash_wv_1 = {
  source: {
    url: 'https://bpcdnmanprod.nexttv.ht.hr/bpk-tv/CinestarTV_Premiere2/default/index.mpd',
    type: 'application/dash+xml',
    drmProtected: true
  },
  metadata: {
    title: 'HT WV 1',
    index: 1,
  },
  autoplay: true,
  drm: {
    env: 'HeaderDrm',
    offlineId: 'arty_ht_1',
    customData: {
      userId: '',
      sessionId: '',
      merchant: '',
      widevineLicenseUrl: 'https://widevine.entitlement.theplatform.eu/wv/web/ModularDrm/getRawWidevineLicense?schema=1.0&form=json&releasePid=FzywWbuXLxs6',
      fairPlayContentIdStrategy: 'full-skd',
      headers: {
        authorization: 'Basic aHR0cDovL2FjY2Vzcy5hdXRoLnRoZXBsYXRmb3JtLmNvbS9kYXRhL0FjY291bnQvMjcwOTM3NTU2NDpleUpoYkdjaU9pSlNVelV4TWlKOS5leUp6ZFdJaU9pSnRhSEp3Y205a0xXRm5aSEl2TVRFd01ETXpNREV3TUNJc0ltbHpjeUk2SWpFaUxDSmxlSEFpT2pFM01UQXlNemd3TkRJc0ltbGhkQ0k2TVRjd09UWXpNekkwTWpJMU1Td2lhblJwSWpvaVpHVmpaVGhpTnpRdE1tSXdNeTAwT0dZM0xXSTROVE10WVRGa1lUZGtOMk5qWXpOaUlpd2laR2xrSWpvaWJXaHljSEp2WkMxaFoyUnlJaXdpZFc1dElqb2lNVEV3TURNek1ERXdNQ0lzSW1OMGVDSTZJbnRjSW1sa1hDSTZYQ0l4TVRBd016TXdNVEF3WENJc1hDSjFjMlZ5VG1GdFpWd2lPbHdpTVRFd01ETXpNREV3TUZ3aUxGd2laVzFoYVd4Y0lqcGNJbHdpTEZ3aVpuVnNiRTVoYldWY0lqcGNJbHdpTEZ3aVlYUjBjbWxpZFhSbGMxd2lPbnRjSW0xaGVDMXpkSEpsWVcxelhDSTZYQ0pzYVcxcGRDMDBYQ0lzWENKMWNtNDZkR2hsY0d4aGRHWnZjbTA2WTI5dWMzVnRaWEk2WVdOamIzVnVkRndpT2x3aWFIUjBjSE02THk5aFkyTnZkVzUwY3k1aGRXUnBaVzVqWlM1MGFHVndiR0YwWm05eWJTNWxkUzloWTJOdmRXNTBjeTh5TnpBNU16YzFOVFkwTHpObE1UUXhaV0UyTFRnellqSXROR013TWkxaU5tVXlMVE5tTWpNMlpqTXlNemRqTlZ3aUxGd2lkWEp1T25Sb1pYQnNZWFJtYjNKdE9tTnZibk4xYldWeU9tRmpZMjkxYm5RNmNHVnljMjl1WVZ3aU9sd2lhSFIwY0hNNkx5OWhZMk52ZFc1MGN5NWhkV1JwWlc1alpTNTBhR1Z3YkdGMFptOXliUzVsZFM5aFkyTnZkVzUwY3k4eU56QTVNemMxTlRZMEx6TmxNVFF4WldFMkxUZ3pZakl0TkdNd01pMWlObVV5TFRObU1qTTJaak15TXpkak5TOXdaWEp6YjI1aGN5OHlaamc1TnpSak5DMHhNVEV5TFRSaE5HTXRPR1ZoWVMwM1pESXhNell6WlRVME5ESmNJbjBzWENKdmQyNWxja2xrWENJNlhDSmNJbjFjYmlJc0ltOXBaQ0k2SWpJM01Ea3pOelUxTmpRaWZRLkVZTFl6S1d2dFZ5WElVVGJNZ3NkUTdqbWQ2ZWtSTW1NT1dzUEQxWTdZRC1CUHpZREUwdTFXWExzQWFfSHVBbGpSbDY4U25pbmFFQ25UUGJXaVhOakJiaHhtRmxNY2FOdVBOWndFMU82WkdSYnFIOE1PTXpoS3JCSkdSQ3h4Y3RJT2VQdk9MR05wM0JOeThmeGxINXYzSUFfQkZfdXczTVE3N3V0LVRGZUsyWnJlTlFtOWRrdnBuSTJvZ1NKRUI4b2Y5d1lLOUxBbkZfUWpLXzUzR20wSEUzUjRqemREZXB3YTVuU1ZnTnY3eUtORzFqa2ZlY3FzUThMS216bUFSUXhNUGhFaW51dF84RWhBWXpndWRqcGUtcF9vZzBfXzFMMWFaenlPMnlKQnhqWU5DZWFzekMyclJzd01Jemk0ZDB1c0RDdTJlYkgyMnN5dXdOUTJEdnFrUQ=='
      },
      deviceId: '',
      httpHeaderNames: {
        DeviceId: 'DeviceId',
        Authenticator: 'Authenticator'
      }
    },
  },
  streaming: {
    rebufferingGoal: 1,
    bufferingGoal: 1,
    startAtSegmentBoundary: true,
    ignoreDrift: true
  },
};

const configs = {
  vod: [
    config_vod_1,
    config_vod_2,
    config_vod_3,
    config_vod_4,
  ],
  live: [
    config_live_1,
    config_live_2,
    config_live_3,
    config_live_4b,
    config_live_4,
    config_live_5,
    live_proximus_1,
    live_ht_dash_1,
    live_ht_dash_wv_1,
    live_ht_dash_1,
    config_bad,
  ],
};

export const PLAYLIST_CONFIGS = configs.vod;
